export default __webpack_public_path__ + "static/142-44daa47fc6d39274845c09b511fe172f.jpg";